import { MUTATION_PREFLOW_UUID } from '@/constants';

export default function getMutationUrl({
  policyId,
  partyId,
  type,
}: {
  policyId?: string;
  partyId?: string;
  type?: 'COMPANY' | 'CUSTOMER';
}) {
  if (!policyId || !partyId || !type) return '';

  const url = new URL(
    `/mutation-preflow/${MUTATION_PREFLOW_UUID}/reason`,
    import.meta.env.VITE_PLATFORM_HOST,
  );

  url.searchParams.set('insurance_policy_id', policyId);
  url.searchParams.set('party_id', partyId);
  url.searchParams.set('type', type);

  return url.toString();
}
